// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = (): JSX.Element => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" fill="#335131" />
        <g clipPath="url(#clip0_113773_47211)">
            <path
                d="M18.3707 29.5241C15.2502 29.5241 12.6106 28.3971 10.7356 26.2661C8.97232 24.2593 8 21.4374 8 18.3208C8 11.7584 12.5716 7.17578 19.1173 7.17578C21.6641 7.17578 24.4081 7.9131 25.9974 8.64286L26.5573 12.7526L26.3591 12.8033C24.4608 9.24307 22.26 7.72418 19.0013 7.72418C13.2739 7.72418 9.855 11.686 9.855 18.3208C9.855 24.9556 13.0809 28.9768 18.4846 28.9768C22.3992 28.9768 24.7899 27.106 26.4751 22.722L26.6712 22.7728L26.0997 27.2506C24.9228 28.1877 21.739 29.5252 18.3696 29.5252L18.3707 29.5241Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_113773_47211">
                <rect width="19" height="23" fill="white" transform="translate(8 7)" />
            </clipPath>
        </defs>
    </svg>
);

export default LogoIcon;
